import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { setActiveItem, toggleEditPanel, updateEditableSlider } from '../../../containers/Editor/actions';
import EditPanel from '../../../containers/Editor/EditPanel';
import SliderPanel from '../../../containers/Editor/EditPanel/SliderPanel';
import VisibilityToggle from '../../../containers/Editor/VisibilityToggle';
import { EditableType, IGNORE_PAGE_CLICK_CLASSNAME } from '../../../containers/Editor/constants';
import { getBorderWidth } from '../../../containers/Editor/utils/helpers';
import { StyledSliderEditor, IconWrapper, Border } from './styles';
import Utils from '../../../utils';

interface SliderEditorProps {
	page: number;
	id: string;
	isActive: boolean;
	pageScale: number;
	isEditPanelDisplayed: boolean;
	isVisible: boolean;
	parentContainer: HTMLElement;
	dispatch: Dispatch<StoreState>;
}

const SliderEditor = ({
	page,
	id,
	isActive,
	isVisible,
	pageScale,
	isEditPanelDisplayed,
	parentContainer,
	dispatch,
}: SliderEditorProps) => {
	const handleClick = () => {
		if (!isActive) {
			dispatch(setActiveItem(id, page, null));

			if (!isEditPanelDisplayed) {
				dispatch(toggleEditPanel());
			}
		}
	};

	const handleVisibilityToggle = () => {
		dispatch(updateEditableSlider(page, id, {
			isVisible: !isVisible,
		}, true, true, true));
	};

	const renderEditPanel = () => (
		isActive && isEditPanelDisplayed && (
			<EditPanel
				defaultType={EditableType.slider}
				panels={{
					[EditableType.slider]: <SliderPanel page={page} />,
				}}
			/>
		)
	);

	React.useEffect(() => {
		parentContainer.style.overflow = 'visible';
	}, []);

	return (
		<>
			<StyledSliderEditor
				className={IGNORE_PAGE_CLICK_CLASSNAME}
				isVisible={isVisible}
				onClick={handleClick}
				onTouchEnd={handleClick}
			>
				{isVisible &&
					<IconWrapper>
						{Utils.getSvgIcon('iconset_uprez_slider')}
					</IconWrapper>
				}
				{(isActive || !isVisible) &&
					<Border
						isActive={isActive}
						borderWidth={getBorderWidth(pageScale)}
					/>
				}
			</StyledSliderEditor>
			<VisibilityToggle
				isVisible={isVisible}
				isParentActive={isActive}
				pageScale={pageScale}
				onToggle={handleVisibilityToggle}
			/>
			{renderEditPanel()}
		</>
	);
};

export default SliderEditor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/SliderEditor/index.tsx